"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagIcon = void 0;
const core_shared_1 = require("@ikegps/core-shared");
const is_missing_true_size_1 = require("../../components/red.dot/is.missing.true.size");
const theme_1 = require("../../components/theme");
const mithril_1 = require("../../mithril");
const store_1 = require("../../store");
const tag_icon_style_1 = require("./tag.icon.style");
(0, theme_1.addStyles)(tag_icon_style_1.Style);
exports.TagIcon = {
    view(tag, summary, color, showRedDot) {
        const value = summary != null ? summary.revisions.length : null;
        showRedDot = showRedDot || exports.TagIcon.checkMissingTrueSize(summary);
        return (0, mithril_1.m)('div', {
            className: tag_icon_style_1.CSS.container,
            style: {
                'border-color': core_shared_1.ColorHash.hash(tag.objectId),
                'background-color': color ? color : '#FFFFFF',
            },
        }, [value, showRedDot ? (0, mithril_1.m)('span', { className: tag_icon_style_1.CSS.redDot }) : null]);
    },
    checkMissingTrueSize(summary) {
        if (summary == null) {
            return false;
        }
        // If the server-side flag is already set, use it directly
        if (summary.hasCollectionsMissingTrueSize != null) {
            return summary.hasCollectionsMissingTrueSize;
        }
        // Fall back to checking individual collection summaries.
        // getShowRedDot caches computed values on each collection summary.
        for (const revision of summary.revisions) {
            const collSummary = store_1.AppStore.CollectionSummary.get(revision);
            if (collSummary != null && (0, is_missing_true_size_1.getShowRedDot)(collSummary)) {
                summary.hasCollectionsMissingTrueSize = true;
                return true;
            }
        }
        return false;
    },
};
//# sourceMappingURL=tag.icon.js.map